var getGlobal = function () {
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    return {};
};
var globals = getGlobal();

// Adyen SDK
const adyen = require("./adyen.encrypt.nodom.js");
globals.adyen = adyen;

// Ingenico Connect SDK
if (!globals.forge) {
    const forge = require("./forge.min.js");
    globals.forge = forge;
}

// INICIS SDK
require("./INIStdPay.js");
